import { NavLink } from 'react-router'

function HeroBanner() {
  return (
    <section className="mt-10 rounded-2xl bg-gradient-to-br from-black to-gray-900 p-10">
      <h1 className="text-3xl font-bold leading-tight">
        Register to unlock more <br />
        <span className="text-green-400">MQT</span> Information and the Mystery Box
      </h1>

      <button className="mt-6 px-6 py-3 rounded-xl bg-blue-600">
        Get Started
      </button>
    </section>
  )
}

const features = [
  {
    title: 'Event',
    desc: 'Simple prediction, instant settle',
  },
  {
    title: 'Rhythm',
    desc: 'Trade in sync, settle together',
  },
  {
    title: 'Ticket',
    desc: 'Challenge up to 10,000x leverage',
  },
]

function FeatureGrid() {
  return (
    <section className="mt-10 grid grid-cols-3 gap-6">
      {features.map(item => (
        <div
          key={item.title}
          className="rounded-2xl border border-white/10 bg-black p-6 hover:border-blue-500 transition"
        >
          <h3 className="text-lg font-semibold">{item.title}</h3>
          <p className="mt-2 text-sm text-gray-400">{item.desc}</p>

          <div className="mt-4 text-blue-500">→</div>
        </div>
      ))}
    </section>
  )
}


const markets = [
  { symbol: 'BTC/USDT', price: '91898.34', change: '-1.93%' },
  { symbol: 'ETH/USDT', price: '3218.36', change: '+2.35%' },
  { symbol: 'SOL/USDT', price: '137.64', change: '-2.49%' },
  { symbol: 'BTC/USDT', price: '91898.34', change: '-1.93%' },
  { symbol: 'ETH/USDT', price: '3218.36', change: '+2.35%' },
  { symbol: 'SOL/USDT', price: '137.64', change: '-2.49%' },
]

function CryptoMarket() {
  return (
    <section className="mt-14">
      <h2 className="mb-4 text-xl font-semibold">Crypto Market</h2>

      <div className="rounded-xl border border-white/10 overflow-hidden">
        {markets.map(item => (
          <div
            key={item.symbol}
            className="grid grid-cols-4 px-6 py-4 border-b border-white/10 last:border-none"
          >
            <div>{item.symbol}</div>
            <div>{item.price}</div>
            <div className="text-gray-400">24H</div>
            <div
              className={`text-right ${
                item.change.startsWith('-')
                  ? 'text-red-500'
                  : 'text-green-500'
              }`}
            >
              {item.change}
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}
function Header() {
  const navs = [
    { label: 'Home', path: '/' },
    { label: 'Trade', path: '/trade' },
    { label: 'AI Market', path: '/ai-market' },
    { label: 'Earn', path: '/earn' },
    { label: 'Assets', path: '/assets' },
  ]
  return (
    <header className="fixed top-0 left-0 z-10 w-full h-16 bg-black/80 flex items-center justify-between px-8 border-b border-white/10">
      <div className="mx-auto w-full h-16 px-6 flex items-center justify-between">
        {/* Logo */}
        <div className="text-xl font-bold text-white">
          MEXQuick
        </div>

        {/* Main Nav */}
        <nav className="hidden lg:flex gap-8 text-sm">
          {navs.map(nav => (
            <NavLink
              key={nav.path}
              to={nav.path}
              className={({ isActive }) =>
                isActive
                  ? 'text-white'
                  : 'text-gray-400 hover:text-white'
              }
            >
              {nav.label}
            </NavLink>
          ))}
        </nav>

        {/* User Actions */}
        <div className="flex items-center gap-4">
          <button className="text-sm text-gray-300 hover:text-white">
            Log in
          </button>
          <button className="px-4 py-2 rounded-lg bg-blue-600 text-sm">
            Register
          </button>
        </div>
      </div>
    </header>
  )
}

export default function HomePage() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Header />

      <main className="mx-auto  px-6 pt-14 pb-4">
        <HeroBanner />
        <FeatureGrid />
        <CryptoMarket />
      </main>
    </div>
  )
}
